import { put, takeLatest } from 'redux-saga/effects';
import { SendLicenseDetails } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// utils
import format from 'date-fns/format';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, email } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Email/SendLicenseDetails/'
            + pk + '/'
            + (email ? null : email), {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });


        const responseResult = yield response.text();


        if (responseResult === Message.EmailSent) {
            yield put(SendLicenseDetails.creators.sendLicenseDetailsSuccess({ isSent: responseResult }));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio è un errore, rimuovo [ERR] all'inizio
            yield put(SendLicenseDetails.creators.sendLicenseDetailsFailed(responseResult.substring(5)));
        }
        else if (responseResult.substring(0, 5) === MessageType.Warning) {
            //se il messaggio è un warning, rimuovo [WAR] all'inizio
            yield put(SendLicenseDetails.creators.sendLicenseDetailsFailed(responseResult.substring(5)));
        }
        else yield put(SendLicenseDetails.creators.sendLicenseDetailsFailed(responseResult));


    } catch (e) {
        yield put(SendLicenseDetails.creators.sendLicenseDetailsFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(SendLicenseDetails.types.SEND_LICENSE_DETAILS_REQUEST, runAction);
}